import * as React from "react";
import ContainerBox from "myshubhlife-component/container-box";
import {connect} from "react-redux";
import {useHistory} from "react-router-dom";
import {useState, useEffect} from "react";
import {drawdown, getDrawdownInfo} from "Loans/Rloc/Withdraw/api";
import {TextField, Button, Loading} from "web-com";
import {CC_EMAIL_ID} from "utils/variables";
import "./styles.scss";
import {Loan} from "Loans/interface";
import {PaymentDetailsRoutes} from "Loans/routes";
import {convertObjectToString} from "Loans/utils";
import BasicCard from "myshubhlife-component/card";
import {CardRow} from "Loans/utils";

interface IConnectProps {
  isAndroid: boolean;
  loanIndex: number;
  loanList: Loan[];
}

const Withdraw = (props: IConnectProps) => {
  const history = useHistory();
  const [amount, updateAmount] = useState<number>(null);
  const [isActive, updateIsActive] = useState(false);
  const [errMsg, updateErrMsg] = useState(null);
  const [bankAcctDetails, updateBankAcctDetails] = useState(null);
  const [loanId, updateLoanId] = useState(null);
  const [availLimit, updateAvailLimit] = useState(null);
  const [isExpired, setIsExpired] = useState(false);
  const [inputDebounce, setInputDebounce] = useState<NodeJS.Timeout | number>();
  const [drawDownDetails, setDrawDownDetails] = useState<{convenienceFee: number, convenienceFeeGst: number}>(null);
  const [isDrawDownDetailsError, setIsDrawDownDetailsError] = useState<boolean>();

  useEffect(() => {
    if (props.loanList && props.loanList.length) {
      const rlocLoan = {...props.loanList[props.loanIndex].state['loan_detail']['loanDetail'],
      availableLimit: props.loanList[props.loanIndex].state['available_limit'],
      is_expired: props.loanList[props.loanIndex].state.is_expired};
      updateBankAcctDetails(rlocLoan.bankAccounts.sort((a, b) => b.verifiedAt - a.verifiedAt));
      updateLoanId(rlocLoan['loanId']);
      updateAvailLimit(rlocLoan['availableLimit']);
      setIsExpired(rlocLoan["is_expired"]);
    }
  }, [props.loanList]);

  const withdraw = async (amount: number) => {
    updateIsActive(true);
    try {
      const res = await drawdown({amount: Number(amount), loanId});
      res && history.replace({pathname: `/${PaymentDetailsRoutes.LOANS}/${PaymentDetailsRoutes.RLOC_DETAILS}`, state: {withdraw: true}});
    } catch (err) {
      err.response && err.response.data ? updateErrMsg(convertObjectToString(err.response.data)): updateErrMsg('Something Went Wrong. Please Try Again.');
      updateIsActive(false);
    }
  }

  const fetchDrawDown = async (val: number) => {
    try {
      const res = await getDrawdownInfo(loanId, val);
      setDrawDownDetails(res);
    } catch (error) { } finally {
      setIsDrawDownDetailsError(true);
    }
  }

  const onChangeHandler = (fieldName: string, val: number) => {
    updateErrMsg("");
    setIsDrawDownDetailsError(false);
    setDrawDownDetails(null);
    clearTimeout(inputDebounce as NodeJS.Timeout);
    if (+val && val <= availLimit) {
      setInputDebounce(setTimeout(() => fetchDrawDown(val), 1000));
    } else {
      isExpired ? updateErrMsg("Loan Tenure has expired") : updateErrMsg("Amount should be within Available Limit");
    }
    +val === 0 && updateErrMsg(`Please Enter amount between 0 and ${availLimit}`);
    updateAmount(val);
  }

  return (
    <>
      <Loading active={isActive} />
      {loanId &&
      <ContainerBox pageTitle={!props.isAndroid ? "Withdraw" : ""} showBackButton={true}>
        <div className="withdraw-container">
          <BasicCard headerTitle={"Account Details"}>
            <div className="details-container">
              <CardRow title='Account Number' value={`************${Number(bankAcctDetails[0].accountNumber) % 1000}`}/>
              <CardRow title='Bank Name' value={bankAcctDetails[0].bankName}/>
            </div>
          </BasicCard>
          <div className="label-container">
            <TextField
              type='number'
              placeholder='Please Enter Amount'
              value={amount || ''}
              fieldName='amount'
              onChange={onChangeHandler}
              max='30'
            />
          </div>
          {drawDownDetails && 
            <BasicCard>
              <div className="details-container">
                <div className="charges-label">Below charges will apply on this drawdown:</div>
                <CardRow title="Convenience Fee" value={drawDownDetails.convenienceFee ? drawDownDetails.convenienceFee.toFixed(2) : 0}/>
                <CardRow title="Convenience Fee Gst" value={drawDownDetails.convenienceFeeGst ? drawDownDetails.convenienceFeeGst.toFixed(2) : 0}/>
              </div>
            </BasicCard>
          }
          {!drawDownDetails && isDrawDownDetailsError && <p className="drawdown-msg">* Convenience Fee and GST will be applicable on the amount drawdown.</p>}
          <p className="limit-details">Available Balance <span>{availLimit > 0 ? availLimit.toFixed(2) : 0}</span></p>
          {errMsg && <p className="error-message">{errMsg}</p>}
          <Button
            buttonText="Confirm"
            onClick={() =>  amount && !errMsg && withdraw(amount)}
            fontWeight='bold'
            isDisabled={!isDrawDownDetailsError}
          />
          <p className="support-message">
            Please contact us at
            <span><a className="contact-link" href="mailto:support@myshubhlife.com"> {CC_EMAIL_ID} </a></span>
            for further support.
          </p>
        </div>
      </ContainerBox>
      }
    </>
  );
};

const mapStateToProps = (state): IConnectProps => {
  return {
      isAndroid: state.login.isAndroid,
      loanIndex: state.loanDetails['loanIndex'],
      loanList: state.loanDetails['loansList'] ? state.loanDetails['loansList']: [],
  };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(Withdraw);
